import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/usersReducer";
import rootSaga from "./redux/usersSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { UsersModule } from "./UsersModule";

const Users = (props) => {
  const { notifications } = props;

  return (
    <Provider store={createReduxStore(reducer, "users", rootSaga)}>
      <ErrorBoundary moduleName="users" {...notifications}>
        <UsersModule />
      </ErrorBoundary>
    </Provider>
  );
};

export default Users;
